import { format, parseISO } from "date-fns";
import { ja } from "date-fns/locale";

import type {
  BankAccount,
  KyashTransferKind,
  KyashTransferStatus,
} from "@/gql/__generated__/graphql";

// サーバーは保留を送金中（sending）として返すため、ワーカーには4つの状態だけを見せる
export const KYASH_TRANSFER_STATUS_LABELS: Record<KyashTransferStatus, string> =
  {
    accepted: "申請受付",
    sending: "送金中",
    completed: "振込完了",
    failed: "振込失敗",
  };

export const KYASH_TRANSFER_STATUS_COLORS: Record<KyashTransferStatus, string> =
  {
    accepted: "blue",
    sending: "orange",
    completed: "green",
    failed: "red",
  };

export const KYASH_TRANSFER_KIND_LABELS: Record<KyashTransferKind, string> = {
  application: "申請",
  auto: "自動",
  resend: "再送",
};

export const BANK_ACCOUNT_TYPE_LABELS: Record<BankAccount, string> = {
  ordinary: "普通",
  checking: "当座",
};

// 振込申請を受け付けなかった理由（サーバーの extensions.code）
export const KYASH_TRANSFER_TARGETS_CHANGED = "KYASH_TRANSFER_TARGETS_CHANGED";

/** 次回自動振込日（例: 2026年11月13日（金）） */
export const formatAutoTransferDate = (date: string) =>
  format(parseISO(date), "yyyy年M月d日（E）", { locale: ja });

/** 振込履歴の申請日時（例: 2026/10/16 15:44） */
export const formatRequestedAt = (dateTime: string) =>
  format(parseISO(dateTime), "yyyy/MM/dd HH:mm");

export const formatYen = (amount: number) => `¥${amount.toLocaleString()}`;
